import { isArtboardElementType, isGroupElementType } from './elementUtils'
import {
  InspectorLayersTreeNode,
  InspectorLayersTreeArtboardLayerNode,
  InspectorLayersTreeBasicLayerNode,
} from './types/DeprecatedInspectorLayersTreeNode'

/**
 * @deprecated Use isArtboardElement from elementUtils.ts
 * once we are using SketchElementNode instead of InspectorLayersTreeNode
 */
export function isArtboard(
  inspectorLayerTreeNode: InspectorLayersTreeNode
): inspectorLayerTreeNode is InspectorLayersTreeArtboardLayerNode {
  return isArtboardElementType(inspectorLayerTreeNode.type)
}

/**
 * @deprecated Use isGroupElement from elementUtils.ts
 * once we are using SketchElementNode instead of InspectorLayersTreeNode
 */
export function isGroup(
  element: InspectorLayersTreeNode
): element is InspectorLayersTreeBasicLayerNode {
  return isGroupElementType(element.type)
}
